import Client from '../HttpClient';

const DOJO_MODULE_ID = 'dojo';
const DOJO_CONFIG_KEY = 'api_key';

const baseUrl = '/gateway/numbat-api/api/vs/manage/branch-metadata';
const dojoConfigBaseUrl = '/gateway/numbat-api/api/vs/manage/dojo-config';

const list = async (merchantId) => {
	const rows =
		(await Client.get(`${baseUrl}/${merchantId}/list`, {
			moduleId: DOJO_MODULE_ID,
			key: DOJO_CONFIG_KEY,
		})) || [];
	return rows.reduce((acc, item) => {
		if (item && item.branchId) {
			acc[item.branchId] = typeof item.value === 'string' ? item.value : '';
		}
		return acc;
	}, {});
};

// Numbat validates the key against the Dojo API before persisting it, so the
// portal never talks to Dojo directly.
const upsert = async (merchantId, branchId, apiKey) => {
	const normalizedApiKey = (apiKey || '').trim();
	if (!normalizedApiKey) {
		throw new Error('Dojo API key is required.');
	}
	await Client.post(`${dojoConfigBaseUrl}/${merchantId}/${branchId}/api-key`, {
		value: normalizedApiKey,
	});
	return list(merchantId);
};

const remove = async (merchantId, branchId) => {
	await Client.del(`${baseUrl}/${merchantId}/${branchId}`, {
		moduleId: DOJO_MODULE_ID,
		key: DOJO_CONFIG_KEY,
	});
	return list(merchantId);
};

export default {
	list,
	upsert,
	remove,
};
